import React from "react";

const UEFCourseDetails = () => {
    return (
        <div style={{ textAlign: "center", marginTop: "50px" }}>
            <h1>Welcome to the AI Generated Course Details Application!</h1>
        </div>
    );
};

export default UEFCourseDetails;
